import { fetchApi } from '@vend/utilities'

export interface TaxInformation {
  tax_name: string
  tax_number_name: string
  tax_number_name_abrv: string
  tax_number: string
  has_tax_number?: boolean | null
  is_tax_info_collection_enabled: boolean
}

const GET_TAX_INFO_PATH = '/api/2.0/billing/tax-information'

export const getTaxInformation = async (): Promise<TaxInformation> => {
  const response = await fetchApi(GET_TAX_INFO_PATH, {
    method: 'GET',
  })

  if (!response.ok) {
    throw new Error('Failed to get tax information')
  }

  const dataObj = await response.json()
  return dataObj.data
}
